import { MotionProps, Variant } from 'motion/react';

export const lessonCardAnimation: Pick<MotionProps, 'initial' | 'animate' | 'exit'> = {
  initial: { opacity: 0, height: 0 },
  animate: {
    opacity: 1,
    height: 'auto',
    transition: {
      type: 'spring' as const,
    },
  },
  exit: { opacity: 0, height: 0 },
};

export const buildMotionLIProps = (
  i: number,
  direction: 'right' | 'left' = 'left',
  delay = 0.1,
) => {
  const variants: Record<'animate' | 'initial', Variant> = {
    animate: (i: number) => ({
      x: 0,
      opacity: 1,
      transition: {
        type: 'spring' as const,
        duration: 0.2,
        delay: 0.05 + i * delay,
        mass: 0.8,
      },
    }),
    initial: {
      x: direction === 'right' ? 200 : -200,
      opacity: 0,
    },
  };

  return {
    variants,
    animate: 'animate',
    initial: 'initial',
    custom: i,
  };
};
